/** First year paystub data exists for; the switcher runs from here to today. */
export const PAYSTUBS_FIRST_YEAR = 2024;
